// apps/scheduler-worker/src/components/TaskTimer.tsx
import { Timer } from 'lucide-react';
import { useElapsedTimer, formatElapsedTime } from '../hooks/useElapsedTimer';
import { cn } from 'scheduler-ui';

interface TaskTimerProps {
  startTime: string | null;
  isRunning: boolean;
  className?: string;
}

export function TaskTimer({ startTime, isRunning, className }: TaskTimerProps) {
  const elapsed = useElapsedTimer({ startTime, isRunning });

  if (!isRunning) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex items-center gap-3 bg-green-50 border border-green-200 rounded-xl p-4',
        className
      )}
    >
      <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
        <Timer className="w-6 h-6 text-green-600 animate-pulse" />
      </div>
      <div>
        <p className="text-sm text-green-700 font-medium">Time Elapsed</p>
        <p className="text-2xl font-mono font-bold text-green-900 tabular-nums">
          {formatElapsedTime(elapsed)}
        </p>
      </div>
    </div>
  );
}
